import { format } from 'date-fns';

export const getTimeTrackDefaultValues = (defaultDate?: Date, defaultProjectId?: string) => {
  return {
    projectId: defaultProjectId ?? '',
    date: defaultDate ?? new Date(),
    startTime: format(new Date(), 'HH:mm'),
    duration: {
      hours: 0,
      minutes: 0,
      seconds: 0,
    },
  };
};
